export var alphabeticalSorting = function (x, y) {
    if (!x.name) {
        return 1;
    }
    if (!y.name) {
        return -1;
    }
    return x.name.toLocaleLowerCase().localeCompare(y.name.toLocaleLowerCase());
};
//# sourceMappingURL=alphabeticalSorting.js.map